module.exports = __webpack_public_path__ + "img/es-box4-text-light.9e4d5134.png";